import script from "./KBasicPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./KBasicPopup.vue?vue&type=script&setup=true&lang=ts"

import "./KBasicPopup.vue?vue&type=style&index=0&id=61a95924&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a95924"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
